var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconmonstr-whatsapp-4 copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0.0-Donation",
    transform: "translate(-1320.000000, -1297.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-icons",
    transform: "translate(1304.000000, 1120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-whatsapp-4-copy",
    transform: "translate(0.000000, 161.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#1DA2F2",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998771,5 C7.58197213,5 4,7.89169134 4,11.4591186 C4,13.7957847 5.53713293,15.8427452 7.83939026,16.976694 C7.79218464,18.4766765 6.70030886,19 6.70030886,19 C6.70030886,19 9.33743104,18.8497823 9.33644759,17.6775475 C9.33644759,17.6368229 9.32440033,17.5909772 9.30350201,17.5417175 C10.1460731,17.7850897 11.0537978,17.9182372 11.9998771,17.9182372 C16.4182737,17.9182372 20,15.026302 20,11.4591186 C20,7.89169134 16.4182737,5 11.9998771,5",
    id: "Fill-149",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIMessage);
export default __webpack_public_path__ + "static/media/IMessage.d9eb3ed082a296b6569c18cfe2132162.svg";
export { ForwardRef as ReactComponent };